import { useState, useEffect, useMemo } from "react";
import { Button, Modal, Form, ListGroup, Spinner, Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

// import { useChat } from "../../AChatWindow/hooks/useChat";
import avatarImg from "../../../assets/images/avatar.svg";
import { createThread, fetchUsers } from "../../../Redux/new-chat-store/chatSlice";
import UserChatBubble from "../../Forms/FirmUserBtn";
import { formatName } from "../../AChatWindow/components/ChatWindow";
//
const cleanUrl = (url) => {
  if (!url) return url;

  // check if the path (before ?) ends with .pdf
  const [base] = url.split("?");
  return base.toLowerCase().endsWith(".pdf") ? base : url;
};
const ChatDocumentModal = ({
  showModal,
  handleClose,
  docName,
  documentURL,
  documentData,
  _selectedFirm,
  users,
  loading,
  error,
  sendMessage,
  searchUsers,
  setChatDocumentThread,
  setUpdatedUser,
  handleSelectUser,
}) => {
  const dispatch = useDispatch();
  const [selectedUsers, setSelectedUsers] = useState(new Set());
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState(null);
  const [groupName, setGroupName] = useState("");
  const [creatingGroup, setCreatingGroup] = useState(false);
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const firm_id = localStorage.getItem("firm_id");
  useEffect(() => {
    if (!firm_id) return;
    dispatch(
      fetchUsers({
        firmId: firm_id,
        search: "",
      })
    );
  }, [firm_id]);
  // Reset state when modal opens/closes
  useEffect(() => {
    if (showModal) {
      setSelectedUsers(new Set());
      setSending(false);
      setSendError(null);
      setGroupName("");
      setCreatingGroup(false);
      searchUsers(""); // Clear search when opening
    }
  }, [showModal, searchUsers]);

  // Filter out current user from the list
  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      // Filter out current user
      const currentUserId = Number(localStorage.getItem("loggedInUser"));
      const userIdToCheck = user.user_id || user.id;
      return userIdToCheck !== currentUserId;
    });
  }, [users]);

  const handleUserToggle = (user) => {
    const newSelected = new Set(selectedUsers);
    const userKey = user.id || user.user_id;

    if (newSelected.has(userKey)) {
      newSelected.delete(userKey);
    } else {
      newSelected.add(userKey);
    }
    setSelectedUsers(newSelected);
  };

  // const generateDocumentMessage = () => {
  //   const encodedData = encodeURIComponent(JSON.stringify(documentData));
  //   console.log(documentData);
  //   const chatDocumentUrl = `${documentURL}?source=chat&file=document&data=${encodedData}`;

  //   return `📄 **Document Shared**: ${docName}\n\n🔗 <a href="${chatDocumentUrl}" data-document-modal="true" data-document-name="${docName}" data-document-url="${chatDocumentUrl}" className="document-link" style="color: #0D6EFD">Click to View Document</a>\n\nClick the link above to view the document.`;
  // };
  const generateDocumentMessage = () => {
    const docURL = cleanUrl(documentURL);
    const encodedData = encodeURIComponent(JSON.stringify(documentData));
    const chatDocumentUrl = `${docURL}?source=chat&file=document&data=${encodedData}`;
    const displayName = (docName || "Document").replace(/\.[^./\\]+$/, "");

    return `<a href="${chatDocumentUrl}" data-document-modal="true" data-document-name="${docName}" data-document-url="${chatDocumentUrl}" className="icon-text-box height-25 font-weight-semibold btn-hover-document-row cursor-pointer" style="display:flex;align-items:center;justify-content:center;gap:5px;max-width:255px;padding:0 5px;border:1px solid var(--primary);border-radius:0;background-color:var(--primary-10);color:var(--primary);text-decoration:none;overflow:hidden"><span className="d-flex align-items-center"><i className="ic ic-15 ic-file-colored"></i></span><span className="name" style="color:var(--primary);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${displayName}</span></a>`;
  };
  // const handleSendDocument = async () => {
  //   console.log(selectedUsers);
  //   if (selectedUsers.size === 0) {
  //     setSendError("Please select at least one user to send the document to.");
  //     return;
  //   }

  //   setSending(true);
  //   setSendError(null);

  //   try {
  //     const documentMessage = generateDocumentMessage();
  //     const promises = [];

  //     // Send to each selected user
  //     for (const userId of selectedUsers) {
  //       const user = filteredUsers.find((u) => (u.id || u.user_id) === userId);
  //       if (user) {
  //         // Get or create thread ID
  //         const threadId = user.threadId || user.id;

  //         // Send message via WebSocket
  //         promises.push(sendMessage(threadId, documentMessage));
  //       }
  //     }

  //     await Promise.all(promises);
  //     handleClose();
  //   } catch (error) {
  //     console.error("Failed to send document:", error);
  //     setSendError("Failed to send document. Please try again.");
  //   } finally {
  //     setSending(false);
  //   }
  // };
  const prefilledText = "Review this document";
  const [value, setValue] = useState(prefilledText);
  const _handleSendDocument = async () => {
    if (selectedUsers.size === 0) {
      setSendError("Please select at least one user to send the document to.");
      return;
    }

    setSending(true);
    setSendError(null);

    try {
      const message = generateDocumentMessage();
      const documentMessage = `${value}\n${message}`;
      const promises = [];

      for (const userId of selectedUsers) {
        // Get full user object
        const user = filteredUsers.find((u) => (u.id || u.user_id) === userId);
        if (!user) continue;

        let threadId = null;

        // CASE 1: User already has a thread (group or 1:1)
        if (user.thread_type) {
          threadId = user.id;
        } else {
          // CASE 2: Create a new 1:1 thread
          const threadResult = await dispatch(
            createThread({
              threadType: "1:1",
              memberIds: [user.id], // this user
            })
          ).unwrap();

          threadId = threadResult?.id;

          if (!threadId) {
            console.error("Failed to create thread for user", user);
            continue;
          }
        }

        // Send message through WebSocket or API
        promises.push(sendMessage(threadId, documentMessage));
      }

      await Promise.all(promises);
      handleClose();
    } catch (error) {
      console.error("Failed to send document:", error);
      setSendError("Failed to send document. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const handleCreateGroupAndSendDocument = async () => {
    if (selectedUsers.size < 2) {
      setSendError("Please select at least 2 users to create a group.");
      return;
    }

    if (!groupName.trim()) {
      setSendError("Please enter a group name.");
      return;
    }

    setCreatingGroup(true);
    setSendError(null);

    try {
      // Get selected user IDs (only individual users, not groups)
      const selectedUserIds = Array.from(selectedUsers)
        .filter((userId) => {
          const user = filteredIndividualUsers.find((u) => (u.id || u.user_id) === userId);
          return user && user.thread_type !== "group";
        })
        .map((userId) => {
          // Find the user object for this ID
          const user = filteredIndividualUsers.find((u) => (u.id || u.user_id) === userId);

          // If user has thread_type, use other_participant_id, otherwise use id
          if (user.thread_type) {
            return user.other_participant_id;
          } else {
            return user.id || user.user_id;
          }
        });
      if (selectedUserIds.length < 2) {
        setSendError("Please select at least 2 individual users to create a group.");
        return;
      }

      // Create the group thread
      const threadResult = await dispatch(
        createThread({
          threadType: "group",
          memberIds: selectedUserIds,
          name: groupName.trim(),
        })
      ).unwrap();

      // Send the document to the newly created group
      const documentMessage = generateDocumentMessage();
      await sendMessage(threadResult.id, documentMessage);

      handleClose();
    } catch (error) {
      console.error("Failed to create group and send document:", error);
      setSendError("Failed to create group and send document. Please try again.");
    } finally {
      setCreatingGroup(false);
    }
  };

  const getUserDisplayInfo = (user) => {
    // Handle different user object structures
    const name =
      user.user?.display_name ||
      user.display_name ||
      user.name ||
      user.client_name ||
      `${user.first_name || ""} ${user.last_name || ""}`.trim() ||
      "Unknown User";

    const avatar = user.user?.avatar_url || user.avatar_url || user.client_avatar;
    const isOnline = user.user?.is_online || user.is_online || false;

    return { name, avatar, isOnline };
  };

  const filteredGroupMembers = filteredUsers.filter((u) => u.thread_type === "group");
  const filteredIndividualUsers = filteredUsers.filter((u) => u.thread_type !== "group");
  // Count selected individual users (not groups)
  const selectedIndividualUsersCount = Array.from(selectedUsers).filter((userId) => {
    const user = filteredIndividualUsers.find((u) => (u.id || u.user_id) === userId);
    return user && user.thread_type !== "group";
  }).length;

  // const handleSendChatWithDocument = async () => {
  //   if (selectedUsers.size === 0) {
  //     setSendError("Please select at least one user to send the document to.");
  //     return;
  //   }

  //   setSendError(null);

  //   try {
  //     for (const userId of selectedUsers) {
  //       // Get full user object
  //       const user = filteredUsers.find((u) => (u.id || u.user_id) === userId);
  //       if (!user) continue;

  //       let threadId = null;

  //       if (user.thread_type) {
  //         threadId = user.id;
  //         const newUser = {
  //           ...user,
  //           threadId,
  //         };
  //         handleSelectUser(newUser);
  //       } else {

  //         handleSelectUser(user);
  //       }

  //       setChatDocumentThread(true);
  //       const updatedUser = {
  //         ...user,
  //         threadId,
  //       };
  //       setUpdatedUser(updatedUser);
  //     }

  //     handleClose();
  //   } catch (error) {
  //     console.error("Failed to send document:", error);
  //     setSendError("Failed to send document. Please try again.");
  //   }
  // };
  const handleSendChatWithDocument = async () => {
    if (selectedUsers.size === 0) {
      setSendError("Please select at least one user to send the document to.");
      return;
    }

    setSending(true);
    setSendError(null);

    try {
      const message = generateDocumentMessage();
      const documentMessage = `${value}\n${message}`;
      const promises = [];

      for (const userId of selectedUsers) {
        // Get full user object
        const user = filteredUsers.find((u) => (u.id || u.user_id) === userId);
        if (!user) continue;

        let threadId = null;

        // CASE 1: User already has a thread (group or 1:1)
        if (user.thread_type) {
          threadId = user.id;
          const updatedUser = {
            ...user,
            threadId,
          };
          setUpdatedUser(updatedUser);
          handleSelectUser(updatedUser);
        } else {
          // CASE 2: Create a new 1:1 thread
          const threadResult = await dispatch(
            createThread({
              threadType: "1:1",
              memberIds: [user.id], // this user
            })
          ).unwrap();

          threadId = threadResult?.id;

          if (!threadId) {
            console.error("Failed to create thread for user", user);
            continue;
          }
          const updatedUser = {
            ...user,
            threadId,
          };
          handleSelectUser(updatedUser);
          setUpdatedUser(updatedUser);
        }

        // Send message through WebSocket or API
        promises.push(sendMessage(threadId, documentMessage));
      }
      setChatDocumentThread(true);

      await Promise.all(promises);
      handleClose();
    } catch (error) {
      console.error("Failed to send document:", error);
      setSendError("Failed to send document. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const isDisabled =
    selectedIndividualUsersCount < 2 ||
    !groupName.trim() ||
    creatingGroup ||
    sending ||
    loading.users;

  // const isDisabled2 = selectedUsers.size === 0 || sending || loading.users || creatingGroup;
  const isNotDisable = selectedUsers?.size === 1;

  if (!showModal) return null;

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      centered
      dialogClassName="custom-group-modal-width"
      style={{
        zIndex: 1000000,
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0, 0, 255, 0.1)",
      }}
    >
      <Modal.Header
        style={{
          backgroundColor: "#003366",
          padding: "0px",
        }}
      >
        <Modal.Title
          className="text-center w-100"
          style={{
            backgroundColor: "#003366",
            color: "white",
            padding: "0px",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Chat About Document
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "5px", maxHeight: "60vh", overflowY: "auto" }}>
        <>
          {/* User Search */}

          <>
            {/* Users List */}
            <div className="m-b-5">
              <div className="">
                <textarea
                  rows={3}
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  style={{
                    width: "100%",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    resize: "none",
                    height: "50px",
                    fontSize: "14px",
                    fontWeight: "400",
                    border: "1px solid var(--primary-25)",
                    borderRadius: "0px",
                    color: "black",
                  }}
                  className="form-control"
                />
              </div>
              <Form.Label>
                <strong>Select Users to Share With:</strong>
              </Form.Label>

              {loading.users ? (
                <div
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "5px",
                    scrollbarWidth: "none",
                  }}
                  className="text-center p-3"
                >
                  <Spinner animation="border" size="sm" className="me-2" />
                  Loading users...
                </div>
              ) : error.users ? (
                <Alert variant="danger">Error loading users: {error.users}</Alert>
              ) : filteredUsers.length === 0 ? (
                <Alert variant="info">No users found. Try a different search term.</Alert>
              ) : (
                <>
                  <h6 className="fw-bold m-b-5">All Users</h6>

                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      gap: "5px",
                    }}
                  >
                    {filteredIndividualUsers.map((user) => {
                      const userKey = user.id || user.user_id;

                      const { name, avatar, _is_online } = getUserDisplayInfo(user);

                      return (
                        <ListGroup.Item
                          key={userKey}
                          className="d-flex align-items-center"
                          style={{
                            cursor: "pointer",
                            border: "none",
                            padding: "0px",
                            gap: "5px",
                            margin: 0,
                          }}
                          onClick={() => handleUserToggle(user)}
                        >
                          <input
                            type="checkbox"
                            checked={selectedUsers.has(userKey)}
                            onChange={() => handleUserToggle(user)}
                            className="d-flex align-items-center m-0 justify-content-center form-check"
                            style={{
                              width: "14px",
                              height: "14px",
                              minHeight: "14px",
                              cursor: "pointer",
                            }}
                          />

                          {/* <img
                            src={avatar ?? ""}
                            alt={name}
                            width="29"
                            height="29"
                            className="rounded-circle me-2"
                            style={{ objectFit: "cover", border: "2px solid var(--primary-25)" }}
                          />

                          <span className="fw-medium">{name}</span> */}
                          <UserChatBubble
                            userId={
                              user?.other_participant_id ??
                              user?.user_id ??
                              (user?.thread_type ? undefined : user?.id)
                            }
                            first_name={name}
                            last_name={""}
                            profilePic={avatar ?? ""}
                            is_active={user?.is_active}
                            width={29}
                            isActive={
                              userOnlineStatus?.[user?.id]?.isOnline ||
                              userOnlineStatus?.[user?.other_participant_id]?.isOnline ||
                              false
                            }
                          />
                        </ListGroup.Item>
                      );
                    })}
                  </div>
                  <hr className="my-1" />

                  <>
                    <h6 className="fw-bold m-b-5">Groups</h6>

                    <div
                      style={{
                        overflowY: "auto",
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "5px",
                      }}
                    >
                      {filteredGroupMembers.map((group) => {
                        const groupKey = group.id || group.user_id;
                        const { name } = getUserDisplayInfo(group);

                        return (
                          <ListGroup.Item
                            key={groupKey}
                            style={{
                              cursor: "pointer",
                              padding: "0px",
                              gap: "5px",
                              border: "none",
                              height: "29px",
                            }}
                            onClick={() => handleUserToggle(group)}
                            className="d-flex align-items-center"
                          >
                            <input
                              type="checkbox"
                              checked={selectedUsers.has(groupKey)}
                              onChange={() => handleUserToggle(group)}
                              className="d-flex align-items-center justify-content-center form-check"
                              style={{
                                width: "14px",
                                height: "14px",
                                cursor: "pointer",
                              }}
                            />
                            <div>
                              <div
                                style={{
                                  paddingLeft: "5px",
                                  flexShrink: 0,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <div>
                                      <div
                                        style={{
                                          margin: "0 0 0px 0",
                                          fontWeight: "600",
                                          color: "#1f2937",
                                          fontSize: "14px",
                                          display: "flex",
                                          height: "29px",
                                          alignItems: "center",
                                          position: "relative",
                                        }}
                                      >
                                        {group?.group_member_avatars
                                          ?.slice(0, 4)
                                          .map((u, index) => {
                                            const isActive =
                                              userOnlineStatus?.[u?.id]?.isOnline || false;
                                            const totalAvatars =
                                              group?.group_member_avatars?.length || 0;
                                            const isLastVisible = index === 3 && totalAvatars > 4;

                                            return (
                                              <div
                                                key={index}
                                                className="ic ic-avatar-index has-avatar-icon-index has-cover-img"
                                                style={{
                                                  width: `${29}px`,
                                                  height: `${29}px`,
                                                  borderRadius: "50%",
                                                  overflow: "hidden",
                                                  marginLeft: index > 0 ? "-8px" : "0px", // Overlap avatars
                                                  position: "relative",
                                                  flexShrink: 0,
                                                  zIndex: 10 - index, // Higher z-index for first avatars
                                                }}
                                              >
                                                {!isLastVisible ? (
                                                  <>
                                                    <img
                                                      src={u?.avatar_url || avatarImg}
                                                      style={{
                                                        width: `${28}px`,
                                                        height: `${28}px`,
                                                        objectFit: "cover",
                                                        borderRadius: "50%",
                                                      }}
                                                      alt="Profile"
                                                    />
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: `${29}px`,
                                                        height: `${29}px`,
                                                        borderRadius: "50%",
                                                        border: isActive
                                                          ? "2.5px solid #009900"
                                                          : "2.5px solid var(--primary-20)",
                                                        pointerEvents: "none",
                                                        zIndex: "1",
                                                      }}
                                                    />
                                                  </>
                                                ) : (
                                                  // Show +X for remaining members
                                                  <div
                                                    style={{
                                                      width: `${29}px`,
                                                      height: `${29}px`,
                                                      borderRadius: "50%",
                                                      backgroundColor: "#e5e7eb",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      fontSize: "12px",
                                                      fontWeight: "600",
                                                      color: "#374151",
                                                      border: "2.5px solid var(--primary-20)",
                                                    }}
                                                  >
                                                    +{totalAvatars - 3}
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                      </div>
                                    </div>
                                    <span className="fw-medium height-25">{formatName(name)}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ListGroup.Item>
                        );
                      })}
                    </div>
                  </>
                </>
              )}
            </div>

            {/* Group Creation Input - Show only when multiple individual users are selected */}
            {selectedIndividualUsersCount >= 2 && (
              <div className="mb-3">
                <Form.Label>
                  <strong>Group Name (for creating new group):</strong>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter group name"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  disabled={creatingGroup}
                />
              </div>
            )}

            {/* Error Display */}
            {sendError && <Alert variant="danger">{sendError}</Alert>}
          </>
        </>
      </Modal.Body>

      <Modal.Footer className=" p-0 mt-0 padding-outside-btn-new-provider">
        <Button
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center  btn"
          variant="secondary"
          onClick={handleClose}
          disabled={sending || creatingGroup}
        >
          Cancel
        </Button>

        {/* Regular Send Document Button */}
        <div
          className="d-flex align-items-center"
          style={{
            gap: "5px",
          }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center  btn"
            variant={!isNotDisable ? "secondary" : "success"}
            onClick={handleSendChatWithDocument}
            disabled={!isNotDisable}
            style={{
              width: "174px",
              minWidth: "174px",
            }}
          >
            Chat About Document
          </Button>
          {/* <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center  btn"
            variant={isDisabled2 ? "secondary" : "success"}
            onClick={handleSendDocument}
            disabled={isDisabled2}
            style={{
              width: "164px",
              minWidth: "164px",
            }}
          >
            {sending ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Sending...
              </>
            ) : (
              `Send Document Link ${selectedIndividualUsersCount >= 2 ? "Individually" : ""}`
            )}
          </Button> */}

          {/* Create Group and Send Document Button - Show only when multiple individual users are selected */}
          {selectedIndividualUsersCount >= 2 && (
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center  btn"
              variant={isDisabled ? "secondary" : "success"}
              onClick={handleCreateGroupAndSendDocument}
              disabled={isDisabled}
              style={{
                width: "166px",
                minWidth: "166px",
              }}
            >
              {creatingGroup ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Creating Group...
                </>
              ) : (
                "Create Group & Send"
              )}
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ChatDocumentModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  docId: PropTypes.string.isRequired,
  docName: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  caseId: PropTypes.number,
  clientId: PropTypes.number,
  documentURL: PropTypes.string.isRequired,
  documentData: PropTypes.object.isRequired,
  selectedFirm: PropTypes.object,
  users: PropTypes.array.isRequired,
  loading: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  sendMessage: PropTypes.func.isRequired,
  searchUsers: PropTypes.func.isRequired,
};

export default ChatDocumentModal;
